import { lightColorTokenObject } from './light-colors.mjs';
import { lightShadowTokenObject } from './light-shadows.mjs';
import { commonTheme } from '../common-theme.mjs';

const lightTheme = {
    colors: lightColorTokenObject.color,
    shadows: lightShadowTokenObject.shadow,
    ...commonTheme,
};

export { lightTheme };
